"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgChevronSLeft(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "9 -4 6 24" }, props),
        React.createElement("path", { d: "M14.53 4.53a.75.75 0 00-1.06-1.06l-4 4a.75.75 0 000 1.06l4 4a.75.75 0 001.06-1.06L11.06 8z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('ChevronSLeft')(SvgChevronSLeft);
//# sourceMappingURL=ChevronSLeft.js.map